import { createAuthClient } from 'better-auth/react';

/** Talks to /api/auth on this same origin (see apps/api/src/auth.ts). */
export const authClient = createAuthClient({ baseURL: window.location.origin, basePath: '/api/auth' });

export const useSession = authClient.useSession;
